<template>
  <v-card>
    <v-card-title class="pb-0">
      <h1 class="headline">
        Настройки
      </h1>
    </v-card-title>
    <v-card-text class="pt-2">
      <v-form v-model="isValid">
        <v-layout row>
          <v-flex xs4>
            <app-reference
              v-model="settings.warehouse"
              class="ma-2"
              label="Склад по умолчанию"
              resource="warehouses"
              component-name="Warehouse"
              :disable-add="true"
              :outline="true"
              :height-field="44"
              @change="isChanged = true"
            />
          </v-flex>
          <v-flex xs4>
            <app-reference
              v-model="settings.currency"
              class="ma-2"
              label="Валюта по умолчанию"
              resource="currencies"
              component-name="Currency"
              :disable-add="true"
              :outline="true"
              :height-field="44"
              @change="isChanged = true"
            />
          </v-flex>
          <v-flex xs4>
            <v-text-field
              v-model="settings.ukraineIsoCode"
              class="ma-2"
              label="Код Украины alpha-3"
              mask="AAA"
              hide-details
              autofocus
              outline
              height="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <MultipleReferenceCompact
              v-model="settings.workWithClientsPositions"
              class="ma-2"
              label="Список должностей, которые работают с Клиентами"
              resource="positions"
              component-name="Position"
              :disabled-add="false"
              :outline="true"
              :height-field="44"
              @input="isChanged = true"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <MultipleReferenceCompact
              v-model="settings.goodsDetailsManagerPositions"
              class="ma-2"
              label="Список должностей, которые работают с Описанием товаров"
              resource="positions"
              component-name="Position"
              :disabled-add="false"
              :outline="true"
              :height-field="44"
              @input="isChanged = true"
            />
            <MultipleReferenceCompact
              v-model="productCategoriesClosedEx"
              class="ma-2"
              label="Список категорий Закрытие ЕХ"
              resource="product-categories"
              component-name="ProductCategory"
              :disabled-add="false"
              :outline="true"
              :height-field="44"
              @input="changedProductCategoriesClosedEx"
            />
          </v-flex>
        </v-layout>
        <v-layout row>
          <v-flex xs12>
            <PeriodsSelect
              v-model="releaseOrderPeriods"
              class="ma-2"
              label="Возможные промежутки отгрузки"
              :resource="releaseOrderPeriodsResourse"
              outline
              height="44"
              @change="changedReleaseOrderPeriods"
            />
          </v-flex>
        </v-layout>
        <v-btn
          small
          color="primary"
          :disabled="!isValid && !isChanged"
          @click="submit()"
        >
          Сохранить
        </v-btn>
        <v-btn
          small
          @click="cancel"
        >
          Отмена
        </v-btn>
      </v-form>
    </v-card-text>
  </v-card>
</template>

<script>
import * as settingsApi from "../../backend/settingsApi.js";
import * as releaseOrderPeriodsApi from "../../backend/releaseOrderPeriodsApi.js";
import PeriodsSelect from "./ReleaseOrderPeriodsSelect";
import * as referenceApi from "../../backend/referenceApi.js";

export default {
  components: {
    PeriodsSelect,
  },
  data() {
    return {
      isValid: false,
      isChanged: false,
      settings: {
        warehouse: null,
        currency: null,
        ukraineIsoCode: "",
        workWithClientsPositions: null,
        goodsDetailsManagerPositions: null,
      },
      productCategoriesClosedEx: null,
      productCategoriesClosedExResourse: "product-categories/closed-ex",
      releaseOrderPeriodsResourse: "release-order-periods",
      releaseOrderPeriods: null,
    };
  },
  created() {
    this.getData();
    this.getReleaseOrderPeriods();
    this.getProductCategoriesClosedEx();
  },
  methods: {
    async getData() {
      const res = await settingsApi.getSettings();
      this.settings.warehouse = res.data.Warehouse
        ? { id: res.data.Warehouse.Id, title: res.data.Warehouse.Title }
        : null;
      this.settings.currency = res.data.Currency
        ? { id: res.data.Currency.Id, title: res.data.Currency.Title }
        : null;
      this.settings.ukraineIsoCode = res.data.UkraineIsoCode;
      this.settings.workWithClientsPositions = res.data.WorkWithClientsPositions.map(
        p => {
          return {
            id: p.Id,
            title: p.Title,
          };
        },
      );
      this.settings.goodsDetailsManagerPositions = res.data.GoodsDetailsManagerPositions.map(
        p => {
          return {
            id: p.Id,
            title: p.Title,
          };
        },
      );
    },
    async getProductCategoriesClosedEx() {
      const res = await referenceApi.getAllReferencies(
        this.productCategoriesClosedExResourse,
      );
      this.productCategoriesClosedEx = res.map(p => {
        return {
          id: p.value,
          title: p.text,
        };
      });
    },
    async getReleaseOrderPeriods() {
      const res = await releaseOrderPeriodsApi.getPeriods(
        this.releaseOrderPeriodsResourse,
      );
      this.releaseOrderPeriods = res.data.map(p => {
        return {
          id: p.Id,
          title: p.Title,
        };
      });
    },
    async submit() {
      const workWithClientsPositionIds = [];
      if (this.settings.workWithClientsPositions != null) {
        this.settings.workWithClientsPositions.map(p =>
          workWithClientsPositionIds.push(p.id),
        );
      }
      const goodsDetailsManagerPositionIds = [];
      if (this.settings.goodsDetailsManagerPositions != null) {
        this.settings.goodsDetailsManagerPositions.map(p =>
          goodsDetailsManagerPositionIds.push(p.id),
        );
      }
      const productCategoriesClosedExIds = [];
      if (this.productCategoriesClosedEx !=null) {
        this.productCategoriesClosedEx.map(p =>
          productCategoriesClosedExIds.push(p.id),
        );
      }

      const settings = {
        warehouseId: this.settings.warehouse
          ? this.settings.warehouse.id
          : null,
        currencyId: this.settings.currency ? this.settings.currency.id : null,
        ukraineIsoCode: this.settings.ukraineIsoCode,
        productCategoriesClosedExIds,
        workWithClientsPositionIds,
        goodsDetailsManagerPositionIds,
      };


      await settingsApi.editSettings(settings);
      this.showInfo("Настройки сохранены");
    },
    cancel() {
      this.$router.go(-1);
    },
    changedReleaseOrderPeriods(periods) {
      this.releaseOrderPeriods = periods;
    },
    changedProductCategoriesClosedEx(category) {
      this.productCategoriesClosedEx = category;
    },
  },
};
</script>
